<template>
  <div class="card border-0 shadow-none rounded-1 mb-30 selected-products-card">
    <div class="card-body p-xl-40">
      <h6 class="fs-18 mb-40 text-title">
        Selected Products For Print Barcode
      </h6>
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ps-0 ls-1">
                PRODUCT
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ls-1">
                PRODUCT CODE
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ls-1">
                PRICE
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ls-1">
                STOCK (BASE QTY)
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ls-1">
                QUANTITY TO PRINT
              </th>
              <th
                scope="col"
                class="text-title fw-normal fs-14 pt-0 ls-1 text-end pe-0"
              >
                DELETE
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in products" :key="product.id">
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph ps-0">
                {{ product.name }}
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                {{ product.code }}
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                ${{ product.price }}
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                {{ product.stock }}
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                <QuantityCounter :model-value="product.qty" @update:modelValue="(q) => stateStore.setProductQty(product.id, q)" />
              </td>
              <td class="shadow-none lh-1 text-end pe-0">
                <div
                  class="button-group style-two ms-auto d-flex flex-wrap align-items-center"
                >
                  <a
                    class="delete-btn"
                    data-bs-toggle="offcanvas"
                    href="#deletePopup"
                    role="button"
                    aria-controls="deletePopup"
                    @click.prevent="remove(product.id)"
                  >
                    <img
                      src="../../../assets/img/icons/close.svg"
                      alt="Image"
                    />
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import QuantityCounter from "./QuantityCounter.vue";
import stateStore from "../../../utils/store";

export default defineComponent({
  name: "SelectedProducts",
  components: {
    QuantityCounter,
  },
  setup() {
    const products = computed(() => stateStore.selectedProducts);
    const remove = (id: number) => stateStore.removeSelectedProduct(id);
    return { products, remove, stateStore };
  },
});
</script>
